import { render, staticRenderFns } from "./BaseExportContact.vue?vue&type=template&id=38f5bd3c&scoped=true&"
import script from "./BaseExportContact.vue?vue&type=script&lang=js&"
export * from "./BaseExportContact.vue?vue&type=script&lang=js&"
import style0 from "./BaseExportContact.vue?vue&type=style&index=0&id=38f5bd3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f5bd3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38f5bd3c')) {
      api.createRecord('38f5bd3c', component.options)
    } else {
      api.reload('38f5bd3c', component.options)
    }
    module.hot.accept("./BaseExportContact.vue?vue&type=template&id=38f5bd3c&scoped=true&", function () {
      api.rerender('38f5bd3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ccd/BaseExportContact.vue"
export default component.exports